'use strict';

var React = require('react');

var SvgTransferInMajor = function SvgTransferInMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.586 13h-6.586a1 1 0 0 1 0-2h6.586l-1.293-1.293a1 1 0 0 1 1.414-1.414l3 3a1 1 0 0 1 0 1.414l-3 3a.997.997 0 0 1-1.631-.324 1 1 0 0 1 .217-1.09l1.293-1.293zm10.414 5.5a1.5 1.5 0 0 1-1.5 1.5h-15a1.5 1.5 0 0 1-1.5-1.5v-3.5h2v3h14v-12.382l-7-3.5-7 3.5v3.382h-2v-4c0-.379.214-.725.553-.895l8-4c.281-.14.613-.14.894 0l8 4c.339.17.553.516.553.895v13.5z"
  }));
};

exports.SvgTransferInMajor = SvgTransferInMajor;
